/**
 * @generated SignedSource<<b6507848383fa3a67a2ef7c1969001b8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SimpleLink_simpleLink$data = {
  readonly label: string | null | undefined;
  readonly url: string;
  readonly " $fragmentType": "SimpleLink_simpleLink";
};
export type SimpleLink_simpleLink$key = {
  readonly " $data"?: SimpleLink_simpleLink$data;
  readonly " $fragmentSpreads": FragmentRefs<"SimpleLink_simpleLink">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SimpleLink_simpleLink",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "label",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "url",
      "storageKey": null
    }
  ],
  "type": "SimpleLink",
  "abstractKey": null
};

(node as any).hash = "3f03dbcb0e7a9c83d48128e134c96a97";

export default node;
